import { render, staticRenderFns } from "./steel.vue?vue&type=template&id=871b961a&scoped=true"
import script from "./steel.vue?vue&type=script&lang=js"
export * from "./steel.vue?vue&type=script&lang=js"
import style0 from "./steel.vue?vue&type=style&index=0&id=871b961a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871b961a",
  null
  
)

export default component.exports